import { isAfter, isValid, isWithinInterval, parse } from 'date-fns'

/** Export Webpack DefinePlugin vars */
declare var process: {
  env: {
    WEBSITE_URL: string
    API_URL: string
    LUIGI_URL: string
    CDN_URL: string
    GOOGLE_MAPS_API_KEY: string
    HEADLESS: string
    ENABLE_TRACKING: string
    SRPRS_ENV: string
    SRPRS_DEV: string
    SRPRS_GIFTCARD_CAMPAIGN_START?: string
    SRPRS_GIFTCARD_CAMPAIGN_END?: string
    SRPRS_SANDBOX: string
  }
}

declare const __webpack_hash__: string

export const WEBSITE_URL = process.env.WEBSITE_URL
export const API_URL = process.env.API_URL
export const LUIGI_URL = process.env.LUIGI_URL
/** Public asset store (images, favicon) — per environment, never hardcoded. */
export const CDN_URL = process.env.CDN_URL
/** Google Maps browser key — per environment; restrict it by HTTP referrer. */
export const GOOGLE_MAPS_API_KEY = process.env.GOOGLE_MAPS_API_KEY
export const HEADLESS = `${process.env.HEADLESS}` === `true`
export const ENABLE_TRACKING = `${process.env.ENABLE_TRACKING}` === `true`
export const SRPRS_ENV = process.env.SRPRS_ENV
export const SRPRS_DEV = `${process.env.SRPRS_DEV}` === `true`
export const SRPRS_SANDBOX = `${process.env.SRPRS_SANDBOX}` === `true`
export const WEBPACK_HASH = __webpack_hash__

// "Buy one, give two" gift-card campaign window, dd-MM-yyyy. parse() gives
// 00:00, so START is inclusive and END is exclusive: the window closes when END
// begins. Per environment via the GitHub environment variables
// SRPRS_GIFTCARD_CAMPAIGN_START / _END so dev can run it early and the yearly
// dates no longer need a code change; the defaults are this year's campaign.
export const GIFTCARD_CAMPAIGN_START =
  process.env.SRPRS_GIFTCARD_CAMPAIGN_START || '17-11-2026'
export const GIFTCARD_CAMPAIGN_END =
  process.env.SRPRS_GIFTCARD_CAMPAIGN_END || '28-12-2026'

export const isThanksgivingCampaign = () => {
  const startDate = parse(GIFTCARD_CAMPAIGN_START, 'dd-MM-yyyy', new Date())
  const endDate = parse(GIFTCARD_CAMPAIGN_END, 'dd-MM-yyyy', new Date())
  // A typo in a variable must switch the campaign off, not throw on every page.
  if (!isValid(startDate) || !isValid(endDate) || isAfter(startDate, endDate)) {
    return false
  }
  return isWithinInterval(new Date(), {
    start: startDate,
    end: endDate,
  })
}

export const SRPRS_GIFTCARD_CAMPAIGN = isThanksgivingCampaign()
  ? 'christmas-campaign'
  : 'default'
